import React from 'react';
import moment from 'moment';

import { MainContent, PageHeading } from '../components/Shell/Content';
import DataTable from '../components/DataTable';

import useAsync from '../hooks/useAsync';

import { getAllEvents } from '../api/admin';

const Events = () => {
	const { value: events } = useAsync(getAllEvents);
	return (
		<MainContent maxWidth="w-full">
			<PageHeading>Events</PageHeading>

			<DataTable
				data={{ rows: events?.filter((e) => e.type !== 'asset.created') || [] }}
				columns={[
					{
						header: 'Organization',
						accessorKey: 'organization.name',
						cell: (info) => info?.getValue() || '',
					},

					{
						header: 'Status',
						accessorKey: 'status',
						cell: (info) => info?.getValue() || '',
					},
					{
						header: 'Date',
						accessorKey: 'date',
						cell: (info) => {
							const row = info?.row?.original;
							const FORMAT = 'ddd, MMM Do, YYYY [at] H:mm:A';
							if (row?.status === 'ESTIMATED') {
								return moment(row?.estimatedDate).format(FORMAT);
							} else if (row?.status === 'SCHEDULED') {
								return moment(row?.scheduledDate).format(FORMAT);
							} else if (row?.status === 'COMPLETED') {
								return moment(row?.completedDate).format(FORMAT);
							} else if (row?.status === 'SKIPPED') {
								return 'Skipped';
							} else {
								return 'N/A';
							}
						},
					},
					{
						header: 'Last notification',
						accessorKey: 'notificationDate',
						cell: (info) => info?.getValue() || '',
					},
					{
						header: 'Description',
						accessorKey: 'description',
						cell: (info) => info?.getValue() || '',
					},
					{
						header: 'Diff',
						accessorKey: 'diff',
						cell: (info) => info?.getValue() || '',
					},
					{
						header: 'Service',
						accessorKey: 'service.name',
						cell: (info) => info?.getValue() || '',
					},
					{
						header: 'Type',
						accessorKey: 'type',
						cell: (info) => info?.getValue() || '',
					},
					{
						header: 'Notification Settings',
						accessorKey: 'service.notificationSettings',
						cell: (info) => JSON.stringify(info?.getValue()) || '',
					},
				]}
				useExport={false}
				hasCheckboxes={false}
				usePagination={false}
			/>
		</MainContent>
	);
};

export default Events;
